require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ru-pages-organizing-commitee.json") })
        }
      }, "path---ru-pages-organizing-commitee");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ru-pages-organizing-commitee!./.cache/json/ru-pages-organizing-commitee.json
// module id = 778
// module chunks = 231608221292675